export default __webpack_public_path__ + "static/media/EPBA.7512b7a9.jpg";